import { create } from "../../../common/utils/zustand_state_manager";
import { IIncorporacaoRepository } from "../../../features/incorporacao/domain/repositories/incorporacao_repositories";
import { IncorporacaoRepository } from "../../../features/incorporacao/data/repositories/incorporacao_repositories";
import { useIncorporacaoServices } from "./use_services";

/**
 * useIncorporacaoRepositories
 */

type State = {
  incorporacaoRepository: IIncorporacaoRepository,
};

export const useIncorporacaoRepositories = create<State>((set, get) => {
  const { incorporacaoService } = useIncorporacaoServices.getState();
  return ({
    incorporacaoRepository: new IncorporacaoRepository(incorporacaoService),
  });

});